import { isEmpty } from "heliocor-ui"
import unionBy from 'lodash/unionBy'

import { getUploadedDocumentsData, isDocumentVisible } from "../../utils/documents"

export const isCategoryConditionSatisfied = ({dependency, values, isRequest}) => {
    const condition = isRequest ? dependency?.CAFE_PHASE_2 : dependency?.CAFE_PHASE_1

    if(!dependency.field || !dependency.type) return true

    switch(dependency.type) {
        case 'SELECT':
            const value = values[dependency.field]?.value || values[dependency.field]
            return condition && value && Array.isArray(value)
                ? dependency.values.some(v => value.includes(v))
                : dependency.values.includes(value)
        case 'BOOLEAN':
            return condition && condition?.[values?.[dependency.field]];
        default:
            return false
    }
}

export const isKycTypeConditionSatisfied = ({field, kycType}) => {
    const kycTypeVisibility = field.dependencies?.kycTypesVisibility || {}
    return isEmpty(kycTypeVisibility) || !!kycTypeVisibility[kycType]
}

export const getOwnerRequestedDocs = (typeOfNewEntity, preApprovalDocs, isRequest, docs, values, fieldsConfig, documentsUploaded) => {
    const { authorizedSignatory, director, shareholder, ubo } = values
    const { authorizedSignatoryDocs, directorDocs, shareholdersDocs, uboDocs } = docs

    let mergedKYC = []

    // We always show company documents for either companies or connected companies
    if (typeOfNewEntity === 'COMPANY') {
        mergedKYC = preApprovalDocs.find(party => party.code === 'COMPANY')?.categories
    } else {
        if (isRequest) {
            mergedKYC = authorizedSignatory ? mergeKYCConfigs([], authorizedSignatoryDocs) : mergedKYC
            mergedKYC = director ? mergeKYCConfigs(mergedKYC, directorDocs) : mergedKYC
            mergedKYC = shareholder ? mergeKYCConfigs(mergedKYC, shareholdersDocs) : mergedKYC
            mergedKYC = ubo ? mergeKYCConfigs(mergedKYC, uboDocs) : mergedKYC
        } else {
            const _authDocs = preApprovalDocs.find(party => party.code === 'AUTH_SIGNATORY')
            const _directorDocs = preApprovalDocs.find(party => party.code === 'DIRECTOR')
            const _shareholderDocs = preApprovalDocs.find(party => party.code === 'SHAREHOLDER')
            const _uboDocs = preApprovalDocs.find(party => party.code === 'UBO')

            mergedKYC = authorizedSignatory ? mergeKYCConfigs([], _authDocs?.categories) : mergedKYC
            mergedKYC = director ? mergeKYCConfigs(mergedKYC, _directorDocs?.categories) : mergedKYC
            mergedKYC = shareholder ? mergeKYCConfigs(mergedKYC, _shareholderDocs?.categories) : mergedKYC
            mergedKYC = ubo ? mergeKYCConfigs(mergedKYC, _uboDocs?.categories) : mergedKYC
        }
    }

    mergedKYC = mergedKYC.map(kycCategory => {
        const documents = kycCategory.documents.filter((d) => isDocumentVisible(d, values, fieldsConfig))
        const category = { ...kycCategory, documents }
        const categoryDocumentsData = getUploadedDocumentsData(category, documentsUploaded)
        return ({ ...category, ...categoryDocumentsData })
    })

    return mergedKYC
}

//TODO: move to utils
const mergeKYCConfigs = (initialKYC = [], newKYC = []) => {
    newKYC.forEach(cat => {
        const foundCat = initialKYC.find(initCat => initCat.code === cat.code)
        const foundCatIndex = initialKYC.findIndex(initCat => initCat.code === cat.code)
        if (foundCat) return initialKYC.splice(foundCatIndex, 1, { ...cat, minDocuments: Math.max(cat.minDocuments, foundCat.minDocuments), documents: unionBy(cat.documents, foundCat.documents, 'name') })
        return initialKYC.push(cat)
    })

    return initialKYC
}